import { Drawer, Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
// New component with thread lanes visualization
import { ShipmentTimelineWithThreadLines } from "@shared/shipments/timelineWithThreadLinesComponent";
import type {
  ShipmentUpdate,
  EmailSource,
} from "@shared/shipments/timelineWithThreadLinesComponent";
import { EmailThreadComponent } from "../../components/EmailThreadComponent";
import { ShipmentTimelineRemindersComponent } from "../../shipments/ShipmentTimelineRemindersComponent";

interface TimelineSidePanelProps {
  open: boolean;
  onClose: () => void;
  shipmentId?: string;
  updates?: ShipmentUpdate[];
  emailSource?: EmailSource;
  includeInternalReminders?: boolean;
  isAdmin?: boolean;
}

export function TimelineSidePanel({
  open,
  onClose,
  shipmentId,
  updates,
  emailSource,
  includeInternalReminders,
  isAdmin,
}: TimelineSidePanelProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: { sx: { width: 780, display: "flex", flexDirection: "column" } },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 0.5,
          px: 2,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content - Use ShipmentTimelineWithThreadLines (new component with colored lanes) */}
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        {shipmentId && (
          <ShipmentTimelineWithThreadLines
            shipmentId={shipmentId}
            updates={updates}
            emailSource={emailSource}
            includeInternalReminders={includeInternalReminders}
            isAdmin={isAdmin}
            EmailThreadComponent={EmailThreadComponent}
            RemindersComponent={ShipmentTimelineRemindersComponent}
          />
        )}
      </Box>
    </Drawer>
  );
}
